module.exports = __webpack_public_path__ + "e2c31502a5f41cd82c767c7c8ca5cdba.pdf";